import { DASHBOARD_PRICING_FOLLOWUP, PRICING_FOLLOWUP_EDIT } from '@/data/url'
import apiClient from '@/services/apiClient'

const fetchFollowups = async (searchActionId) => {
    const url = DASHBOARD_PRICING_FOLLOWUP
    const res = await apiClient.post(url, { search_action_id: searchActionId })
    return res.data
}

const updateFollowupPrices = async (priceData) => {
    const url = PRICING_FOLLOWUP_EDIT
    const res = await apiClient.post(url, { price_data: priceData })
    return res.data
}

export default {
    fetchFollowups,
    updateFollowupPrices,
}
